export const MULTI_SOCKET_ERROR_MESSAGE_MAP = {
  1016: '잘못된 코드 요청입니다.', // 잘못된 코드 요청
  1023: '호스트 미접속중 입니다.', // 호스트 미접속시
  1026: '동시 접속자 초과하였습니다.', // 이미 통역 중일 때 or 동시 접속자 초과
  1027: '이미 종료된 통역입니다.', // 이미 종료된 통역일 때
  1029: '사용량이 초과되었습니다.', // 사용량 초과
  1030: '동시 접속중 입니다.', // 동시 접속시
  4000: 'wrong_approach', //
  4010: '인증을 실패하였습니다.', // 인증 실패
  4030: 'entry_limited', //
  9999: '', //
};
